import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { Warehouse } from 'src/app/models/Warehouse';
import { WarehouseLocation } from 'src/app/models/WarehouseLocation';
import { WarehouseState } from 'src/app/warehouses/warehouse.state';

import { UpdateWarehouseLocation } from '../warehouse.location.actions';

@Component({
    selector: 'app-warehouse-locations-update-modal',
    templateUrl: './warehouse-locations-update-modal.component.html',
    styleUrls: ['./warehouse-locations-update-modal.component.scss'],
})
export class WarehouseLocationsUpdateModalComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(WarehouseState.Warehouses) warehouses$: Observable<Warehouse[]>;
    @Input() warehouseLocation: WarehouseLocation;

    warehouseLocationFormGroup: FormGroup;
    loading = false;
    inputIsWrong = false;
    newWarehouseLocation: WarehouseLocation;

    saveWarehouseLocationWentWrong = false;
    errorMessage: string;
    DESCRIPTION_MAX_LENGTH = 1000;
    currentAmountOfDescriptionCharacters: number;
    descriptionIsTooLong = false;

    keyword = 'title';
    chosenWarehouse: string;
    allWarehouses: Warehouse[];
    warehouse: Warehouse;

    constructor(
        private formBuilder: FormBuilder,
        public activeModal: NgbActiveModal,
        private store: Store,
        private toastr: ToastrService,
        private logger: NGXLogger,
        private modalService: NgbModal,
    ) {}

    ngOnInit(): void {
        this.warehouses$.subscribe((warehouses) => (this.allWarehouses = warehouses));

        this.warehouseLocationFormGroup = this.formBuilder.group({
            title: ['', [Validators.required]],
            description: [''],
            warehouse: '',
        });

        this.setFormValues();
    }

    setFormValues() {
        this.warehouseLocationFormGroup.setValue({
            title: this.warehouseLocation.title,
            description: this.warehouseLocation.description,
            warehouse: this.warehouse ? this.warehouse : '',
        });
    }

    updateWarehouseLocation() {
        this.loading = true;

        if (!this.warehouseLocationFormGroup.valid) {
            this.inputIsWrong = true;
            this.loading = false;
            return;
        }

        this.newWarehouseLocation = this.warehouseLocationFormGroup.value;
        this.newWarehouseLocation.warehouseUuid = this.warehouseLocationFormGroup.value.warehouse?.uuid;
        this.newWarehouseLocation.uuid = this.warehouseLocation.uuid;
        this.warehouseLocationFormGroup.disable();

        this.logger.debug('Attempt to update warehouseLocation');
        this.subscriptions.add(
            this.store.dispatch(new UpdateWarehouseLocation(this.newWarehouseLocation)).subscribe(
                () => {
                    this.logger.debug('Succesfully updated warehouseLocation');
                    this.activeModal.close();
                    this.toastr.success('Warehouse updated succesfully');
                },
                (errorMessage) => {
                    this.logger.error('Failed to update warehouseLocation');
                    this.errorMessage = errorMessage.error.message ?? 'Error message was empty';
                    this.saveWarehouseLocationWentWrong = true;
                    this.loading = false;
                    this.warehouseLocationFormGroup.enable();
                },
            ),
        );
    }

    // Hides the error messages that appear after a user has submitted invalid data
    hideErrorMessage() {
        this.inputIsWrong = false;
    }

    onDescriptionKeyUp() {
        this.descriptionIsTooLong = false;
        this.currentAmountOfDescriptionCharacters = this.warehouseLocationFormGroup.controls.description.value.length;
        if (this.currentAmountOfDescriptionCharacters > this.DESCRIPTION_MAX_LENGTH) {
            this.descriptionIsTooLong = true;
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
